import {fetchWithTimeout} from "./apiUtils";
import * as cacheUtils from "./cacheUtils";


const PROFILE_SERVER = "https://canopyserver.alurellc.com/api/user_profiles/";
export async function fetchProfileDataByUser(username) {
    let profileData = [];
    try {
        const response = await fetchWithTimeout(`${PROFILE_SERVER}${username}`, {method: 'GET'}, 2000);

        if(!response.ok) {
            throw new Error('fetchCardDataByUser timed out.')
        }

        profileData = await response.json();
    }
    catch (error) {
        console.error("Error fetching profile data by user: ", error);
    }

    return profileData;
}


export async function postProfileData() {
    const userKey = cacheUtils.get("userVal");
    if (!userKey) {
        console.warn("postProfileData: No user key found");
        return false;
    }
    
    try {
        const profile = cacheUtils.getUserProfile(userKey);
        if (!profile) {
            console.warn("postProfileData: No profile data found");
            return false;
        }
        
        const response = await fetchWithTimeout(`${PROFILE_SERVER}update/${userKey}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(profile)
        });

        if (response.ok) {
            console.log("Profile POSTED successfully to DB with response: ", response);
        }
        else {
            console.error("Failed to update profile.");
        }
    }
    catch (error) {
        console.error("Error during profile submit: ", error);
    }
}

export async function loadProfileData(username) {   
    if (!username) return { data: null, fromCache: false };

    // First, try to get profile from localStorage
    const cachedProfile = cacheUtils.getUserProfile(username);
    if (cachedProfile) {
        // Normalize cached profile data
        const normalizedCachedProfile = {
            username: cachedProfile.username || username,
            email: cachedProfile.email || '',
            phone: cachedProfile.phone || '',
            notifications: cachedProfile.notifications === 1 ? true : 
                           cachedProfile.notifications === true ? true : 
                           false,
            location: cachedProfile.location || '',
            admins: cachedProfile.admins || '',
            contributors: cachedProfile.contributors || ''
        };
        return { data: normalizedCachedProfile, fromCache: true };
    }

    // If no cached profile, fetch from API
    try {
        const profileData = await fetchProfileDataByUser(username);   
        if (profileData && profileData.length > 0) {
            const profileItem = profileData[0];
            
            // Ensure the profile item matches the expected structure
            const formattedProfile = {
                username: profileItem.username || username,
                email: profileItem.email || '',
                phone: profileItem.phone || '',
                notifications: profileItem.notifications === 1 ? true : 
                               profileItem.notifications === true ? true : 
                               false,
                location: profileItem.location || '',
                admins: profileItem.admins || '',
                contributors: profileItem.contributors || ''
            };

            // Cache profile data in localStorage for future loads
            cacheUtils.setUserProfile(username, formattedProfile);
            return { data: formattedProfile, fromCache: false };
        }
        else {
            console.error("profileUtils: No profile data found for user: ", username);
            return { data: null, fromCache: false };
        }
    }
    catch (error) {
        console.error("profileUtils: Failed to obtain profile data:", error);
        return { data: null, fromCache: false };
    }
}